import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import { MenuItem, MenuItemType } from '../../../../typings/menu';
import LeftMenuItem from '../../../../components/MenuManager/Left/MenuItem';
import Utils from '../../../../utils';
import DriveItemUtils from '../../../../utils/driveItem';

interface MenuItemOwnProps {
	menuItem: MenuItem;
	badge?: number;
}

enum LocationPathName {
	Folder = '/list/folder',
	Page = '/page',
	Search = '/list/search'
}

const mapStateToProps = (state: StoreState, ownProps: MenuItemOwnProps) => {
	const {
		appInfos,
		routing: { locationBeforeTransitions: { pathname } },
		search,
		galleryInfos: { config },
		routerParamsHistory,
		driveList,
	} = state;
	const { menuItem } = ownProps;
	const { type, target} = menuItem;
	const { isShown, searchString } = search;
	const { driveItems } = driveList;
	const isRoute = Utils.isMenuItemTypeRoute(menuItem.type);
	const isMultiApp = Utils.isMultiApp(appInfos);

	const isItemActive = () => {
		if (menuItem) {
			const targetId = Utils.getMediaId(target);

			if (type === MenuItemType.Folder) {
				return pathname === `${LocationPathName.Folder}/${targetId}`;
			} else if (type === MenuItemType.Page) {
				return pathname === `${LocationPathName.Page}/${targetId}`;
			} else if (type === MenuItemType.SearchButton) {
				return isShown || pathname === `${LocationPathName.Search}/${searchString}`;
			} else if (type === MenuItemType.Documents) {
				const currentFolderId = Utils.getCurrentFolderId(config.applicationGallery, routerParamsHistory);
				const privateDirId = Utils.getPrivateDirId(driveList, config);
				const sharedDirId = Utils.getSharedDirId(driveList, config);
				return pathname.includes(LocationPathName.Folder) &&
					DriveItemUtils.isDirDescendantOf(currentFolderId, privateDirId, driveItems) &&
					!DriveItemUtils.isDirDescendantOf(currentFolderId, sharedDirId, driveItems);
			} else if (type === MenuItemType.SharedWithMe) {
				const currentFolderId = Utils.getCurrentFolderId(config.applicationGallery, routerParamsHistory);
				const sharedDirId = Utils.getSharedDirId(driveList, config);
				return pathname.includes(LocationPathName.Folder) &&
					DriveItemUtils.isDirDescendantOf(currentFolderId, sharedDirId, driveItems);
			} else if (isRoute) {
				return pathname === `/${target}`;
			}
		}

		return false;
	};

	return {
		isActive: isItemActive(),
		isRoute,
		isMultiApp
	};
};

export default connect(mapStateToProps)(LeftMenuItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Left/MenuItem/index.tsx